import React from 'react';
import { PropTypes } from 'prop-types';
import { feeSchedulePrograms as fspUtils } from '@unite-us/client-utils';
import { dollarAmount } from 'common/display/Money/DollarAmount';
import { LineItem } from 'common/display/LineItem';
import formatDate from 'common/utils/Dates/formatDate';
import { isSingleDate } from '../../../utils/serviceAuthorizationUtils';

function RequestDetailsSection({ authorization, isUnitBased, feeScheduleProgram }) {
  const isSingleDateRequested = isSingleDate(authorization, 'requested');

  return (
    <div className="pt-6">
      <h4 className="leading-4 mb-3 uppercase">
        Request Details
      </h4>
      <dl className="grid grid-cols-2 gap-2 m-0">
        <LineItem field="Amount Requested" dataTestElement="amount-requested">
          {authorization.requested_unit_amount ?
            authorization.requested_unit_amount :
            dollarAmount(authorization.requested_cents, true)}
        </LineItem>
        {isSingleDateRequested ? (
          <LineItem field="Service Delivery Date" dataTestElement="service-delivery-date">
            {formatDate(authorization.requested_ends_at)}
          </LineItem>
        ) : (
          <LineItem field="Service Delivery Dates" dataTestElement="service-delivery-dates">
            {formatDate(authorization.requested_starts_at)} -{' '}
            {formatDate(authorization.requested_ends_at)}
          </LineItem>
        )}
        <LineItem field="Payment Approach" dataTestElement="payment-approach">
          {fspUtils.PAYMENT_TYPES[feeScheduleProgram.payment_type]}
        </LineItem>
        {isUnitBased && (
          <LineItem field="Rate" dataTestElement="request-rate">
            {dollarAmount(feeScheduleProgram.unit_rate, true)} per{' '}
            {feeScheduleProgram.unit}
          </LineItem>
        )}
        <LineItem field="Program Cap" dataTestElement="request-cap">
          {/* eslint-disable-next-line react/no-danger */}
          <div dangerouslySetInnerHTML={{ __html: feeScheduleProgram.cap_information || 'N/A' }} />
        </LineItem>
      </dl>
    </div>
  );
}

RequestDetailsSection.propTypes = {
  authorization: PropTypes.shape({
    requested_unit_amount: PropTypes.number,
    requested_cents: PropTypes.number,
    requested_starts_at: PropTypes.string.isRequired,
    requested_ends_at: PropTypes.string.isRequired,
  }).isRequired,
  isUnitBased: PropTypes.bool.isRequired,
  feeScheduleProgram: PropTypes.shape({
    payment_type: PropTypes.string,
    unit_rate: PropTypes.number,
    unit: PropTypes.string,
    cap_information: PropTypes.string,
  }).isRequired,
};

export default RequestDetailsSection;
